'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*  weak */
var Html = function Html(props) {
  var post = props.route.page.data;
  return _react2.default.createElement(
    'div',
    { className: 'markdown' },
    _react2.default.createElement(
      'h1',
      null,
      post.title
    ),
    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: post.body } })
  );
};

Html.propTypes = {
  route: _propTypes2.default.shape({
    page: _propTypes2.default.shape({
      data: _propTypes2.default.object
    })
  })
};

Html.defaultProps = {
  route: {
    page: {
      data: {}
    }
  }
};

exports.default = Html;


//////////////////
// WEBPACK FOOTER
// ../~/gatsby/dist/isomorphic/wrappers/md.js
// module id = 766
// module chunks = 0